import request from '../utils/request'

/**
 * 收货地址相关接口
 */

// 获取地址列表
export function getAddressList() {
  return request({
    url: '/h5/address/list',
    method: 'get'
  })
}

// 获取地址详情
export function getAddressDetail(id) {
  return request({
    url: `/h5/address/${id}`,
    method: 'get'
  })
}

// 获取默认地址
export function getDefaultAddress() {
  return request({
    url: '/h5/address/default',
    method: 'get'
  })
}

// 新增地址
export function addAddress(data) {
  return request({
    url: '/h5/address/add',
    method: 'post',
    data
  })
}

// 修改地址
export function updateAddress(data) {
  return request({
    url: '/h5/address/update',
    method: 'put',
    data
  })
}

// 删除地址
export function deleteAddress(id) {
  return request({
    url: `/h5/address/${id}`,
    method: 'delete'
  })
}

// 设为默认地址
export function setDefaultAddress(id) {
  return request({
    url: `/h5/address/default/${id}`,
    method: 'post'
  })
}
